import { type ReactNode } from "react";

/**
 * Terminal state for a failed route-mode guard when no fallback route is
 * reachable either (e.g. the `common` umbrella product is disabled, which
 * blocks every Ops page the admin has permissions for). Rendering a legible
 * message beats the alternatives — a redirect ping-pong between blocked
 * routes or a silent blank page — and points triage at the product catalog.
 */
const SectionUnavailable = (): ReactNode => (
  <div
    data-testid="section-unavailable"
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      gap: "8px",
      textAlign: "center",
      padding: "0 24px",
    }}
  >
    <h2 style={{ margin: 0 }}>This section isn&apos;t available</h2>
    <p style={{ margin: 0 }}>
      This section isn&apos;t enabled for this environment. Contact an
      administrator if you believe this is an error.
    </p>
  </div>
);

export default SectionUnavailable;
